import { HStack, Text, NativeSelect } from '@chakra-ui/react';
import { useCommitteeHierarchy } from '../../hooks/useCommitteeHierarchy'
import { useCommitteeScope } from '../../hooks/useCommitteeScope'
import { flattenCommitteeOptions } from './committeeSwitcherOptions'

export function CommitteeSwitcher() {
  const { data: hierarchy } = useCommitteeHierarchy()
  const { activeCommitteeId, setActiveCommitteeId } = useCommitteeScope()

  // WL-5: the switcher offers the FULL descendant tree (nested to any depth), not just direct
  // children — flattened into depth-tagged, indented options.
  const options = hierarchy ? flattenCommitteeOptions(hierarchy.children) : []

  // Hide if there is nothing to switch to.
  if (options.length === 0) return null

  return (
    <HStack gap={2}>
      <Text fontSize="sm" color="ink.2" whiteSpace="nowrap">
        Viewing:
      </Text>
      <NativeSelect.Root size="sm">
        <NativeSelect.Field
          maxW="220px"
          value={activeCommitteeId ?? ''}
          onChange={(e) => setActiveCommitteeId(e.target.value || undefined)}>
          <option value="">All Committees</option>
          {options.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.depth > 0 ? `${'  '.repeat(opt.depth)}↳ ${opt.label}` : opt.label}
            </option>
          ))}
        </NativeSelect.Field>
        <NativeSelect.Indicator />
      </NativeSelect.Root>
    </HStack>
  );
}
